<div #snap="itemSnappedHeight"
     class="content-sidebar-list-container"
     [albertItemSnappedHeight]="itemSize()"
>
  @let items = (service().itemList$ | async);
  @let loading = (service().loading$ | async);

  @if (items && items.length > 0) {
    <p-virtualscroller
      styleClass="content-sidebar-list"
      [itemSize]="itemSize()"
      [scrollHeight]="snap.scrollHeight()"
      [items]="items"
      [lazy]="true"
      [loading]="loading ?? false"
      [showLoader]="true"
      [step]="pageSize()"
      (onLazyLoad)="onLoadLazy($event)"
    >
      <ng-template #item
                   let-item
      >
        @if (item) {
          <ng-container
            *ngTemplateOutlet="itemTemplate()!; context: { $implicit: item }"
          />
        } @else {
          <div class="loader-container">
            <p-skeleton class="p-2"
                        height="114px"
                        width="100%"
            />
          </div>
        }
      </ng-template>
    </p-virtualscroller>
  } @else if (loading) {
    <div class="p-2">
      @for (_ of [0, 1, 2, 3, 4, 5]; track _) {
        <p-skeleton class="mb-2"
                    height="122px"
                    width="100%"
        />
      }
    </div>
  }
</div>
